import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Virtuoso } from 'react-virtuoso';
import { List, ListItem, Portal } from '@chakra-ui/react';
import { useSelectContext } from '../../SingleSelect';
import { useSelectPopover } from '../../SingleSelect/components';
import { itemToValue } from '../../SingleSelect/utils';
import { MultiDropdownItem } from './MultiDropdownItem';
export const MultiSelectMenu = () => {
    const { getMenuProps, isOpen, items, nothingFoundLabel, styles, virtualListRef, virtualListHeight, } = useSelectContext();
    const { floatingRef, floatingStyles } = useSelectPopover();
    return (_jsx(Portal, { children: _jsxs(List, { style: floatingStyles, ...getMenuProps({
                hidden: !isOpen,
                ref: floatingRef,
            }, {
                suppressRefError: true,
            }), sx: styles.list, children: [isOpen && items.length > 0 && (_jsx(Virtuoso, { ref: virtualListRef, data: items, overscan: virtualListHeight / 2, style: { height: virtualListHeight }, itemContent: (index, item) => {
                        return (_jsx(MultiDropdownItem, { item: item, index: index }, `${itemToValue(item)}${index}`));
                    } })), isOpen && items.length === 0 ? (_jsx(ListItem, { role: "option", sx: styles.emptyItem, children: nothingFoundLabel })) : null] }) }));
};
